import { Injectable } from '@angular/core';
import { defaultMainTableModifier } from '@prlw/core/monitor/init/common';
import { Modifier, ModifierType } from '@prlw/core/monitor/types/common';
import { UserSettingsController } from '@prlw/core/user-settings/user-settings.controller';
import { Observable, first } from 'rxjs';
import { Setting } from '../user-settings/setting.interface';

const MAIN_TABLE_MODIFIER_SETTING = new Setting<Modifier>(
  'main-table-modifier',
);

@Injectable({
  providedIn: 'root',
})
export class MainTableModifiersService {
  public readonly modifier$: Observable<Modifier>;

  constructor(private readonly userSettingsController: UserSettingsController) {
    this.modifier$ = userSettingsController.setting$(
      MAIN_TABLE_MODIFIER_SETTING,
      defaultMainTableModifier,
    );
  }

  public updateModifier(modifier: Modifier): void {
    this.userSettingsController
      .updateSetting(MAIN_TABLE_MODIFIER_SETTING, modifier)
      .pipe(first())
      .subscribe();
  }

  /**
   * Цена + тариф
   * @param price Цена
   * @param tariffPrice Тариф
   */
  simpleModification(price: number, tariffPrice: number) {
    return price + tariffPrice;
  }

  /**
   * Цена + тариф + маржа
   * @param price Цена
   * @param prepaidMargin Маржа в рублях
   * @param tariffPrice Тариф
   */
  prepaidModification(
    price: number,
    prepaidMargin: number,
    tariffPrice: number,
  ) {
    return price + tariffPrice + prepaidMargin;
  }

  /**
   * На основе исходной цены, процента годовых, периода отсрочки в днях и данных тарифа вовращает цену с отсрочкой
   * платежа.
   * @param price Цена
   * @param deferPercent Процент годовых
   * @param deferPeriod Период отсрочки в днях
   * @param tariffPrice Тариф
   * @param tariffShipmentTime Время отгрузки
   */
  deferModification(
    price: number,
    deferPercent: number,
    deferPeriod: number,
    tariffPrice: number,
    tariffShipmentTime: number,
  ) {
    const nextPrice = price + tariffPrice;
    const period = deferPeriod + tariffShipmentTime;
    const deferCalc = Math.round(
      (nextPrice / 100) * ((deferPercent / 365) * period),
    );
    return nextPrice + deferCalc;
  }

  getModificationValuesPriceByParams(
    price: number,
    tariffPrice: number,
    tariffShipmentTime: number,
    modifier: Modifier,
  ) {
    if (modifier.type === ModifierType.SIMPLE) {
      return this.simpleModification(price, tariffPrice);
    }
    if (modifier.type === ModifierType.PREPAID) {
      return this.prepaidModification(
        price,
        modifier.data.prepaidMargin,
        tariffPrice,
      );
    }
    if (modifier.type === ModifierType.DEFER) {
      return this.deferModification(
        price,
        modifier.data.deferPercent,
        modifier.data.deferPeriod,
        tariffPrice,
        tariffShipmentTime,
      );
    }
    return price;
  }
}
